import React, { Component } from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { localize } from '../util/Localizer'
import Card from '@material-ui/core/Card'
import TitledLine from '../controls/TitledLine'
import RBButton from '../controls/RBButton'
import Divider from '@material-ui/core/Divider'
import TitledLabel from '../controls/TitledLabel'
import Icon from '@material-ui/core/Icon'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { fetchAssociatedClaimLines } from '../redux/actions/associatedClaimLinesActions'
import { injectIntl } from 'react-intl'
import Columns from '../styles/columns'
import CardStyles from '../styles/cards'
import IconStyles from '../styles/icons'
import { push } from 'connected-react-router'
import BackButton from '../controls/BackButton'
import { emptyClaimState } from '../assets/images'
import Isvg from 'react-inlinesvg'
import classnames from 'classnames'

// Member Widgets//
import Header from '../widgets/common/Header'
import Footer from '../widgets/common/Footer'
import Loading from '../widgets/Loading'

class AssociatedClaimLines extends Component {
  constructor (props) {
    super(props)

    this.backToSummary = this.backToSummary.bind(this)
  }

  componentDidMount () {
    if (this.props.associatedClaimsObj) {
      this.props.fetchAssociatedClaimLines(this.props.associatedClaimsObj)
    }
  }
  componentWillUnmount () {
    const locationPath = window.location.pathname.split('/')
    if (!(locationPath[4] === 'ClaimLines' && locationPath[5] === 'Details')) {
      window.localStorage.removeItem('claimsParams')
    }
  }

  backToSummary () {
    this.props.goBack()
  }

  renderClaimLine (claimLine, indx) {
    const { classes = {} } = this.props
    return (<div key={indx}>
      <Card className={ classnames(classes.summaryCard, classes.baseCard) }>
        <Row between='lg' className='summaryHeader'>
          <Col lg={8} md={8} xs={12}>
            <Row between='xs'>
              <Col>
                <TitledLine title='pages.claims.claimNumber' value={claimLine.claimCode} className='claimId claimsTitleLine' />
              </Col>
              <Col className={'claim_responsive_padding'}>
                <TitledLine title='pages.claims.status' value={claimLine.claimStatus} className={`${claimLine.claimStatus} claimsTitleLine`} />
              </Col>
              <Col className={'claim_responsive_padding'}>
                <TitledLine title='pages.claims.name' value={claimLine.patientName} className='claimId claimsTitleLine' />
              </Col>
            </Row>
          </Col>
          <Col lg={4} md={12} xs={12}>
            <Row end='lg'>
              <Col>
                {claimLine.explanationOfBenefitsFileExists === true
                  ? <RBButton
                    variant='outlined'
                    label={localize('pages.claims.eob')}
                    onClick={() => { this.fetchEoBFile(claimLine.eoBFileName) }}
                    icon={<Icon className={classes.borderedIcon}>arrow_downward</Icon>} />
                  : null}
                <RBButton
                  variant='outlined'
                  label={localize('pages.claims.claimDetails')}
                  onClick={() => this.props.push(`/Claims/${claimLine.claimId}/${claimLine.benefitName}/ClaimLines/Details/${claimLine.claimLineId}`)}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col {...Columns.max6}>
            <TitledLabel title='pages.claims.ProcDate' value={claimLine.processedDate} format='date' />
          </Col>
          <Col {...Columns.max6}>
            <TitledLabel title='pages.claims.dateOfService' value={claimLine.serviceDate} format='date' />
          </Col>
          <Col {...Columns.max6}>
            <TitledLabel title='pages.claims.amountSubmitted' value={claimLine.amountSubmitted} format='currency' />
          </Col>
          <Col {...Columns.max6}>
            <TitledLabel title='pages.claims.amountPaid' value={claimLine.amountPaid} format='currency' />
          </Col>
          <Col {...Columns.max6}>
            <TitledLabel title='pages.claims.service' value={claimLine.serviceDescription} />
          </Col>
          <Col {...Columns.max6}>
            <TitledLabel title='pages.claims.benefit' value={claimLine.benefitName} />
          </Col>
        </Row>
      </Card>
    </div>
    )
  }

  renderEmptyClaims () {
    return (
      <div className='emptyStateClaimContainer'>
        <Row middle='xs' className='centered'>
          <Col>
            <Isvg className='emptyClaimState' src={emptyClaimState} />
            <p className='emptyStateText'>{localize('pages.claims.emptyState')}</p>
          </Col>
        </Row>
      </div>
    )
  }

  render () {
    return (
      <div className='pageContent'>
        <Header />
        <section className='mainContent'>
          <Grid fluid>
            <Col xs={12} lgOffset={1} lg={10} className='associatedClaims'>
              <div className='claimLine'>
                {this.props.associatedClaimsObj || this.props.associatedClaimLines ? <BackButton label={localize('pages.claimLines.backButton')} /> : null}
                <h4 className='sectionHeading'>{localize('pages.claimLines.associatedClaimLines')}</h4>
                {!this.props.associatedClaimsObj && !this.props.associatedClaimLines
                  ? this.renderEmptyClaims()
                  : (!this.props.associatedClaimLines ? <Loading message={localize('common.loadingContent')} /> : null)
                }
                {
                  this.props.associatedClaimLines
                    ? (this.props.associatedClaimLines || []).map((claimLine, index) => {
                      return this.renderClaimLine(claimLine, index)
                    }) : null}
              </div>
            </Col>
          </Grid>
          <Footer />
        </section>
      </div>
    )
  }
}

function mapStateToProps (state, ownProps) {
  return {
    associatedClaimLines: state.associatedClaimLinesReducer.associatedClaimLines,
    error: state.associatedClaimLinesReducer.error,
    isLoading: state.associatedClaimLinesReducer.isLoading,
    associatedClaimsObj: window.localStorage.getItem('claimsParams')
    // memberId: ownProps.memberId
  }
}

const ConnectedAssociatedClaimLines = connect(mapStateToProps, { fetchAssociatedClaimLines, push })(injectIntl(AssociatedClaimLines))

const styles = {
  ...CardStyles,
  ...IconStyles
}

export default withStyles(styles)(ConnectedAssociatedClaimLines)



// WEBPACK FOOTER //
// ./src/components/AssociatedClaimLines.js